import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Start collapsed by default
    this.isOpen = false
  }

  toggle() {
    this.isOpen = !this.isOpen
    
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle('hidden', !this.isOpen)
    }
    
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('rotate-180', this.isOpen)
    }
  }
}
